<template>
  <div :class="type==1? 'c-bottom-Adaptive' : 'c-bottom-Adaptive_ios'" :style="appstyle">
    <slot></slot>
  </div>
</template>

<script>
import { appstyle} from "@/utils/index";
export default {
  data() {
    return {
      type:1
    };
  },
  mounted() {
    this.phoneType();
    window.addEventListener("resize", this.phoneType);
  },
  computed: {
    appstyle,
  },
  methods: {
    /*判断客户端*/
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },

    phoneType() {
      let _this = this;
      if(this.judgeClient()=="IOS"){
        this.type = 2
      }else{
        this.type = 1
      }
    },
  },
};
</script>

<style lang="scss"scoped>
    .c-bottom-Adaptive{
        height: 1.48rem /* 111/75 */ !important;
    }
    .c-bottom-Adaptive_ios{
        height:2.066667rem /* 155/75 */ !important;
    }
</style>
